import * as React from 'react';
import Header from './header';
import * as styles from './layout.module.scss';
import ClientAnnouncement from '../announcement/client-announcement';
import GlobalAnnouncement from '../announcement/global-announcement';
import { Switch, Route } from 'react-router-dom';
import BackButton from '../back-button/back-button';
import Paths from '../../models/enums/paths';
import LeftToolbar from './left-toolbar';
import AdminToolbar from './adminToolbar';

const Layout = (props: any) => {
  const userInterface =
    window.env.USER_INTERFACE !== null && window.env.USER_INTERFACE !== undefined
      ? window.env.USER_INTERFACE
      : 'default';

  return (
    <div className={styles.wrapper}>
      <Header />
      <div className={styles.body}>
        <Switch>
          <Route path={[Paths.Help, Paths.Management, Paths.Support, Paths.AddRequest]} render={() => <BackButton />} />
          {userInterface !== 'management' && <Route path="/" component={LeftToolbar} />}
          {userInterface === 'management' && <Route path="/" component={AdminToolbar} />}
        </Switch>
        <div className={styles.main}>
          {userInterface !== 'management' && (
            <React.Fragment>
              <GlobalAnnouncement />
              <ClientAnnouncement />
            </React.Fragment>
          )}
          {props.children}
        </div>
      </div>
    </div>
  );
};
export default Layout;
